import {
  IDmMucThuNienCheCopyRequest,
  IDmMucThuNienCheViewModelRequest,
  IMucThuNienCheApDungRequest,
  IMucThuNienChePreviewRequest,
} from "../../../model/request/category/dmMucThuNienCheRequest";
import {
  IDmMucThuNienChe,
  IMucThuNienCheApDungKetQua,
  IMucThuNienCheSinhVienApDung,
} from "../../../model/respone/category/IDmMucThuNienChe";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDmMucThuNienCheActionsObj = {
  UPDATE_STATUS: {} as eReducerStatusBase,

  LOAD_START: {} as IDmMucThuNienCheViewModelRequest,
  LOAD_SUCCESS: {} as IDmMucThuNienChe[],
  LOAD_ERRR: "",

  SAVE_START: {} as IDmMucThuNienChe[],
  SAVE_SUCCESS: {} as IDmMucThuNienChe[],
  SAVE_ERROR: "",

  CHANGE_REQUEST: {} as IDmMucThuNienCheViewModelRequest,

  LOCK_START: {} as IDmMucThuNienCheViewModelRequest,
  LOCK_SUCCESS: {} as IDmMucThuNienChe[],
  LOCK_ERRR: "",

  UNLOCK_START: {} as IDmMucThuNienCheViewModelRequest,
  UNLOCK_SUCCESS: {} as IDmMucThuNienChe[],
  UNLOCK_ERRR: "",

  SHOWHIDE_COPY_MODAL: {} as boolean,
  COPY_START: {} as IDmMucThuNienCheCopyRequest,
  COPY_SUCCESS: {} as IDmMucThuNienChe[],
  COPY_ERROR: "",

  CHANGE_MODE_EDIT: {} as number,
  CHANGE_EXPANDED_KEYS: {} as string[],

  // --- Tổng hợp tự động: xem trước rồi mới áp dụng ---
  /** Nạp danh sách sinh viên sẽ nhận mức thu để xem trước. */
  PREVIEW_START: {} as IMucThuNienChePreviewRequest,
  PREVIEW_SUCCESS: {} as IMucThuNienCheSinhVienApDung[],
  PREVIEW_ERROR: "",
  DONG_MODAL_AP_DUNG: {} as undefined | boolean,

  AP_DUNG_START: {} as IMucThuNienCheApDungRequest,
  AP_DUNG_SUCCESS: {} as IMucThuNienCheApDungKetQua,
  AP_DUNG_ERROR: "",
  /** Đóng bảng theo dõi tiến trình sau khi áp dụng xong. */
  DONG_PROCESS: {} as undefined | boolean,
};

export const eDmMucThuNienCheActionIds = generateActionTypeIds(
  eDmMucThuNienCheActionsObj,
  "MUC_THU_NIEN_CHE",
);

export type IDmMucThuNienCheActionTypes = IGenericActionType<
  typeof eDmMucThuNienCheActionsObj,
  "MUC_THU_NIEN_CHE"
>;
